"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var LogoMasterCard = function LogoMasterCard() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "36",
    height: "22",
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.8667 2.33667H13.1328V19.5137H22.8667V2.33667Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.7511 10.9253C13.7511 7.43527 15.4197 4.33977 17.9845 2.3368C16.0996 0.880093 13.7202 0 11.1245 0C4.97511 0 0 4.88603 0 10.9253C0 16.9646 4.97511 21.8506 11.1245 21.8506C13.7202 21.8506 16.0996 20.9705 17.9845 19.5138C15.4197 17.5108 13.7511 14.4153 13.7511 10.9253Z",
    fill: "#EB001B"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.9998 10.9253C35.9998 16.9646 31.0247 21.8506 24.8754 21.8506C22.2797 21.8506 19.9003 20.9705 18.0153 19.5138C20.5801 17.5108 22.2488 14.4153 22.2488 10.9253C22.2488 7.43527 20.5801 4.33977 17.9844 2.3368C19.9003 0.880093 22.2797 0 24.8754 0C31.0247 0 35.9998 4.88603 35.9998 10.9253ZM34.9492 17.6929V17.3287H35.1037V17.268H34.7329V17.3287H34.8874V17.6929H34.9492ZM35.6599 17.6929V17.268H35.5363L35.4127 17.5715L35.2891 17.268H35.1655V17.6929H35.2582V17.3591L35.3818 17.6322H35.4745L35.5981 17.3591V17.6929H35.6599Z",
    fill: "#F79E1B"
  }));
};

var _default = LogoMasterCard;
exports.default = _default;